/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.form-buttons[_ngcontent-%COMP%]{text-align:right}.form-submit-button[_ngcontent-%COMP%]{margin-left:5px}.form-control[_ngcontent-%COMP%]{border-width:2px}.sizing-form[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus{border-color:#b4a1dd;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(180,161,221,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(180,161,221,.6)}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZm9ybS9jb250cm9sL2Zvcm0tc2l6aW5nL2Zvcm0tc2l6aW5nLWRlbW8uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9mb3JtL2NvbnRyb2wvZm9ybS1zaXppbmcvZm9ybS1zaXppbmctZGVtby5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/form/control/form-sizing/form-sizing-demo.component.scss.shim.ngstyle.ts